import { render, staticRenderFns } from "./KIcon.vue?vue&type=template&id=102c2cb5&scoped=true&"
import script from "./KIcon.vue?vue&type=script&lang=js&"
export * from "./KIcon.vue?vue&type=script&lang=js&"
import style0 from "./KIcon.vue?vue&type=style&index=0&id=102c2cb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102c2cb5",
  null
  
)

export default component.exports